import clsx from "clsx";
import * as React from "react";
import { PaginationProps } from ".";

const range = (start: number, end: number): number[] => {
    const length = end - start + 1;
    return Array.from({ length }, (_, i) => start + i);
};

const ellipsisArray: ["ellipsis"] = ["ellipsis"];

const Pagination: React.FC<PaginationProps> = ({ loading = false, ...props }) => {
    const renderItem = (page: number | "ellipsis", index: number): React.ReactElement => {
        if (page === "ellipsis") {
            return (
                <li key={index}>
                    <div className="tmp-pagination__item-ellipsis">...</div>
                </li>
            );
        }

        return (
            <li key={index}>
                <div
                    className={clsx("tmp-pagination__item-button", {
                        "tmp-active": props.page === page,
                    })}
                    onClick={() => {
                        props.onPageChange(page);
                    }}
                >
                    {page}
                    {loading && props.page === page ? (
                        <i className="tmp-pagination-loading-icon fas fa-circle-notch fa-spin" />
                    ) : null}
                </div>
            </li>
        );
    };

    const boundaryCount = 1;
    const siblingCount = 1;

    const count = Math.ceil(props.total / props.perpage);

    const startPages = range(1, Math.min(boundaryCount, count));
    const endPages = range(Math.max(count - boundaryCount + 1, boundaryCount + 1), count);

    const siblingsStart = Math.max(
        Math.min(props.page - siblingCount, count - boundaryCount - siblingCount * 2 - 1),
        boundaryCount + 2
    );

    const siblingsEnd = Math.min(
        Math.max(props.page + siblingCount, boundaryCount + siblingCount * 2 + 2),
        endPages.length > 0 ? endPages[0] - 2 : count - 1
    );

    const list: (number | "ellipsis")[] = [
        ...startPages,

        // Start ellipsis
        // eslint-disable-next-line no-nested-ternary
        ...(siblingsStart > boundaryCount + 2
            ? ellipsisArray
            : boundaryCount + 1 < count - boundaryCount
            ? [boundaryCount + 1]
            : []),

        // Sibling pages
        ...range(siblingsStart, siblingsEnd),

        // End ellipsis
        // eslint-disable-next-line no-nested-ternary
        ...(siblingsEnd < count - boundaryCount - 1
            ? ellipsisArray
            : count - boundaryCount > boundaryCount
            ? [count - boundaryCount]
            : []),

        ...endPages,
    ];

    return (
        <ul className="tmp-pagination">
            {props.page > 1 ? (
                <li>
                    <div
                        className="tmp-pagination__item-button"
                        onClick={() => {
                            props.onPageChange(props.page - 1);
                        }}
                    >
                        <i className="fas fa-angle-left"></i>
                    </div>
                </li>
            ) : null}
            {list.map((item, index) => renderItem(item, index))}
            {props.page < count ? (
                <li>
                    <div
                        className="tmp-pagination__item-button"
                        onClick={() => {
                            props.onPageChange(props.page + 1);
                        }}
                    >
                        <i className="fas fa-angle-right"></i>
                    </div>
                </li>
            ) : null}
        </ul>
    );
};

export default Pagination;
